import { AccessRightService } from '@fi-shared/fi-shared-services/access-right.service';

export const FiStateResolveAccessRightFilterCollection = [
    AccessRightService,
    FiStateResolveAccessRightFilterCollectionResolveFunc,
];

export function FiStateResolveAccessRightFilterCollectionResolveFunc(accessRightService: AccessRightService) {
    return accessRightService.GetAccessRightsForRequestAccess();
}
